export const TheEnd = () => {
  return (
    <div
      className="flex-center flex-col"
      style={{
        minHeight: "100vh",
        padding: "0 24px",
        textAlign: "center",
        fontSize: 20
      }}
    >
      <p style={{ color: "red" }}>This site has been closed.</p>
      <p>
        Check out the lastest version of GI DMG Calculator{" "}
        <a href="https://gidmgcalculator.web.app/" target="_blank">
          here
        </a>
        !
      </p>
    </div>
  );
};
